"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessErrors = exports.checkForDuplicateCodes = exports.postProcessErrors = void 0;
var assert = require("assert");
var symbols_1 = require("./symbols");
/* istanbul ignore next: the goal is not to test each and every error message factory */
var BusinessErrors = (_a = {},
    _a[symbols_1.Segment] = 'E',
    _a.Auth = (_b = {},
        _b[symbols_1.Segment] = '01',
        _b.Unauthorized = {
            code: '0000',
            statusCode: 401,
        },
        _b.TokenExpired = {
            message: 'Le lien a expiré',
            code: '0001',
            statusCode: 410,
        },
        _b.InsufficientPrivileges = {
            code: '0002',
            statusCode: 403,
            message: function (_a) {
                var neededRole = _a.neededRole;
                return "role ".concat(neededRole, " is needed to perform this action");
            },
        },
        _b),
    _a.Internal = (_c = {},
        _c[symbols_1.Segment] = '00',
        _c.Generic = {
            message: "Une erreur s'est produite, veuillez essayer à nouveau",
            code: '0000',
            statusCode: 500,
        },
        _c.LocalCallFailed = {
            message: function (context) {
                return "Local call to ".concat(context.url, " failed: ").concat(context.response);
            },
            code: '0001',
            statusCode: 500,
        },
        _c.ExternalCallFailed = {
            message: function (context) {
                return "External call to ".concat(context.url, " failed: ").concat(context.response);
            },
            code: '0002',
            statusCode: 500,
        },
        _c.WrongVirtualHost = {
            message: 'No site configured for this host',
            code: '0003',
            statusCode: 404,
        },
        _c.Validation = (_d = {},
            _d[symbols_1.Segment] = '00',
            _d.Generic = {
                message: function (context) {
                    return "Validation error: ".concat(context.message);
                },
                code: '0000',
                statusCode: 400,
            },
            _d),
        _c),
    _a.Validation = {
        message: function (context) {
            return "Validation error: ".concat(context.message);
        },
        code: '0005',
        statusCode: 400,
    },
    _a.Account = (_e = {},
        _e[symbols_1.Segment] = '12',
        _e.AlreadyExists = {
            message: 'Ce compte existe déjà',
            code: '0000',
            statusCode: 400,
        },
        _e.NotFound = {
            message: "Le compte n'existe pas",
            code: '0001',
            statusCode: 404,
        },
        _e.InvalidConfiguration = {
            message: function (context) {
                return "Probl\u00E8me de configuration du magasin : ".concat(context.message);
            },
            code: '0002',
            statusCode: 500,
        },
        _e),
    _a.Logistics = (_f = {},
        _f[symbols_1.Segment] = '14',
        _f),
    _a.Signature = (_g = {},
        _g[symbols_1.Segment] = '17',
        _g.NotAuthorized = {
            message: 'Non autorisé',
            code: '0000',
            statusCode: 403,
        },
        _g),
    _a.User = (_h = {},
        _h[symbols_1.Segment] = '18',
        _h.AlreadyExists = {
            message: 'Cet utilisateur existe déjà',
            code: '0000',
            statusCode: 400,
        },
        _h.NotFound = {
            message: "L'utilisateur n'existe pas",
            code: '0001',
            statusCode: 404,
        },
        _h.NotCompatible = {
            message: "L'action demandée ne peut pas être effectuée pour cet utilisateur",
            code: '0002',
            statusCode: 422,
        },
        _h.PasswordInvalid = {
            message: "Le mot de passe n'est pas valide",
            code: '0003',
            statusCode: 400,
        },
        _h.CantGrantRole = {
            message: 'Vous ne pouvez pas accorder ce rôle',
            code: '0004',
            statusCode: 403,
        },
        _h),
    _a);
exports.BusinessErrors = BusinessErrors;
var isErrorContainer = function (e) {
    return Object.prototype.hasOwnProperty.call(e, symbols_1.Segment);
};
/**
 * Create final error codes from the structure defined above.
 * @param e - Error object.
 * @param path - Array of segments to build up error code path.
 */
function postProcessErrors(e, path) {
    if (path === void 0) { path = []; }
    if (isErrorContainer(e)) {
        var segment_1 = e[symbols_1.Segment];
        assert(/^[A-Z0-9]+$/.test(segment_1), // Alphanumeric characters
        "Segment in ".concat(path.join('_'), " is invalid"));
        Object.values(e).forEach(function (node) {
            postProcessErrors(node, __spreadArray(__spreadArray([], path, true), [segment_1], false));
        });
    }
    else {
        var error = e;
        var finalCode = __spreadArray(__spreadArray([], path, true), [e.code], false).join('_');
        assert.strictEqual(error.code.length, 4, "Code in ".concat(finalCode, " has an invalid size"));
        e.code = finalCode;
    }
}
exports.postProcessErrors = postProcessErrors;
function checkForDuplicateCodes(tree) {
    var flatten = function (node, path, flat) {
        if (path === void 0) { path = []; }
        if (flat === void 0) { flat = {}; }
        if (isErrorContainer(node)) {
            Object.keys(node).forEach(function (k) { return flatten(node[k], path.concat(k), flat); });
            return flat;
        }
        var code = node.code;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        flat[code] = flat[code] || [];
        flat[code].push(path.join('.'));
        return {};
    };
    var flat = flatten(tree);
    var duplicates = Object.keys(flat).reduce(function (memo, code) {
        var matches = flat[code];
        if (matches.length > 1) {
            memo.push({ code: code, matches: matches });
        }
        return memo;
    }, []);
    if (duplicates.length) {
        throw new Error("Duplicate error codes:\n".concat(duplicates
            .map(function (d) { return "Code ".concat(d.code, " appears in ").concat(d.matches.join(', ')); })
            .join('\n')));
    }
}
exports.checkForDuplicateCodes = checkForDuplicateCodes;
postProcessErrors(BusinessErrors);
